import { CosmeticType } from '@push.io/shared';
import type { CosmeticSlotKey } from './types.js';

export const SLOT_BY_TYPE: Partial<Record<CosmeticType, CosmeticSlotKey>> = {
  [CosmeticType.BaseColor]: 'baseColorId',
  [CosmeticType.Skin]: 'skinId',
  [CosmeticType.Pattern]: 'patternId',
  [CosmeticType.Flag]: 'flagId',
  [CosmeticType.Letter]: 'letterId',
  [CosmeticType.Accessory]: 'accessoryId',
  [CosmeticType.Trail]: 'trailId',
  [CosmeticType.Nameplate]: 'nameplateId',
  [CosmeticType.Badge]: 'badgeId',
  [CosmeticType.VictoryEffect]: 'victoryEffectId',
};
